import { Star, Quote } from "lucide-react";
import { useLang, loc } from "../i18n";
import { Reveal, SectionHead } from "./Reveal";

export const Reviews = ({ reviews }) => {
  const { lang, t } = useLang();
  return (
    <section id="reviews" data-testid="reviews-section" className="border-t border-white/10 bg-[#070707]">
      <div className="mx-auto max-w-[1500px] px-5 py-24 md:px-10 md:py-32">
        <SectionHead num={t.reviews.num} title={t.reviews.title} sub={t.reviews.sub} testid="reviews-head" />
        <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3">
          {reviews.map((r, i) => (
            <Reveal key={r.id} delay={(i % 3) * 0.08}>
              <figure
                data-testid={`review-card-${r.id}`}
                className="flex h-full flex-col border border-white/10 bg-[#0A0A0A] p-7 transition-colors duration-500 hover:border-[#FF5A00]/50"
              >
                <div className="flex items-center justify-between">
                  <div className="flex gap-1" data-testid={`review-stars-${r.id}`}>
                    {Array.from({ length: r.rating }).map((_, j) => (
                      <Star key={j} size={15} className="fill-[#FF5A00] text-[#FF5A00]" />
                    ))}
                  </div>
                  <Quote size={22} className="text-neutral-700" />
                </div>
                <blockquote className="mt-5 flex-1 text-sm leading-relaxed text-neutral-300">
                  {loc(r.text, lang)}
                </blockquote>
                <figcaption className="mt-6 flex items-center gap-4 border-t border-white/10 pt-5">
                  {r.avatar ? (
                    <img src={r.avatar} alt={r.name} loading="lazy" className="h-11 w-11 rounded-full object-cover" />
                  ) : (
                    <span className="flex h-11 w-11 items-center justify-center rounded-full bg-[#FF5A00] font-display text-lg">
                      {r.name?.[0]}
                    </span>
                  )}
                  <div>
                    <p className="text-sm font-bold">{r.name}</p>
                    <p className="text-xs uppercase tracking-wider text-neutral-500">PROALP22</p>
                  </div>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
